import React from "react";
import { H2 } from "../../utils/typography";
type CaseStudySectionProps = {
  label: string;
  children: React.ReactNode;
};

/** Editorial two-column section: a small sticky label on the left, content on the right. */
export function CaseStudySection({
  label,
  children
}: CaseStudySectionProps) {
  return <section className="grid grid-cols-1 gap-6 lg:grid-cols-12 lg:gap-12" data-id="element-30" data-mp="4pil2jpoidax">
      <h2 className={`${H2} text-espresso lg:sticky lg:top-32 lg:col-span-4 lg:self-start`} data-id="element-31" data-mp="3d411b8prwz5m">
        {label}
      </h2>
      <div className="lg:col-span-8" data-id="element-32" data-mp="393gyboiir1bk">{children}</div>
    </section>;
}